module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, [_c('a', {
    attrs: {
      "href": "/gjgzhjy/#/mainPage"
    }
  }, [_c('span', {
    staticClass: "remind",
    staticStyle: {
      "float": "left"
    },
    on: {
      "mouseover": _vm.mouseover,
      "mouseout": _vm.mouseout
    }
  }, [_vm._v("您有 " + _vm._s(_vm.unReadNumber) + " 条未读信息")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8aee562"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/messageRemind.vue
// module id = 1895
// module chunks = 502